/*
    © 2023 NetSuite Inc.
    User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
    provided, however, if you are an authorized user with a NetSuite account or log-in, you
    may use this code subject to the terms that govern your access and use.
*/
define('NSeComm.CoreCharge.Main', [
    'CoreCharge.List.View',
    'CoreCharge.MyAccount.List.View',
    'CoreCharge.Model',
    'underscore'
],
function NSeCommOtherChargeMain(
    CoreChargeListView,
    CoreChargeMyAccountListView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var environment = container.getComponent('Environment');
            var summaryTitle = environment.getConfig('coreCharge.title');
            var coreChargeView = new CoreChargeMyAccountListView({
                layout: layout,
                title: summaryTitle
            });

            // Shopping Cart
            layout.addChildViews(layout.ALL_VIEWS, {
                'CartSummary.AfterSubtotal': {
                    'CoreCharge.List': {
                        childViewIndex: 0,
                        childViewConstructor: function addMyAccountSummaryChildView() {
                            return new CoreChargeListView({
                                title: summaryTitle
                            });
                        }
                    }
                }
            });

            // Checkout view
            layout.addChildViews(layout.ALL_VIEWS, {
                'OrderWizardSummary.AfterSubtotal': {
                    'CoreCharge.List': {
                        childViewIndex: 0,
                        childViewConstructor: function addMyAccountSummaryChildView() {
                            return new CoreChargeListView({
                                title: summaryTitle
                            });
                        }
                    }
                }
            });

            if (container.getName() === 'MyAccount') {
                // remove other charge items from order details page:
                layout.addToViewContextDefinition('Transaction.Line.Views.Cell.Actionable.View', 'showGeneralClass', 'boolean', function showClass(context) {
                    return context.item.itemtype === 'OthCharge';
                });
                layout.addToViewContextDefinition('Transaction.Line.Views.Cell.Actionable.View', 'generalClass', 'string', function addHideClass(context) {
                    return context.item.itemtype === 'OthCharge' ? 'hide' : '';
                });

                // get list of other charge amounts to show it in the summary
                layout.addToViewContextDefinition('OrderHistory.Summary.View', 'otherChargeSummary', 'boolean', function refreshDeliveryDates(data) {
                    if (data.model.options && data.model.options.custbody_core_charge_amounts) {
                        layout.cancelableTrigger('otherChargeSummary', data.model.options.custbody_core_charge_amounts);
                    } else {
                        layout.cancelableTrigger('otherChargeSummary', '');
                    }
                    return true;
                });
                layout.addChildView('PurchaseDetailsSummary.AfterSubtotal', function addChildView() {
                    return coreChargeView;
                });
            }
        }
    };
});
